import { GET_ALL_QUEUES, GET_SPECIFIC_QUEUE, GET_QUEUE_USE, GET_ALL_WAIT_MUSIC, GET_ALL_AUDIOS } from './mutation-types'

export default {
  [GET_ALL_QUEUES]: (state, filas) => {
    state.filas = filas
  },
  [GET_SPECIFIC_QUEUE]: (state, fila) => {
    state.fila = fila
  },
  [GET_QUEUE_USE]: (state, filaUse) => {
    state.filaUse = filaUse
  },
  [GET_ALL_AUDIOS]: (state, audios) => {
    state.audios = audios
  },
  [GET_ALL_WAIT_MUSIC]: (state, musicasEmEspera) => {
    state.musicasEmEspera = musicasEmEspera
  },
}
